module.exports = __webpack_public_path__ + "static/img/bg_test1.e0fca4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_test1.png
// module id = 0RaH
// module chunks = 1